// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1WDhy","gfeWrapper":"CalendarEvent_gfeWrapper__3YcwN"};